import { OrderEntity } from './order.entity';
import { TempCartInfo } from './template';
import { OrderDeliveryCheckbox } from './order.delivery-checkbox';

export class OrderUtils extends OrderDeliveryCheckbox {
  /**
   * @returns {FormData}
   * @constructor
   */
  get DataForm() {
    return this.data;
  }

  /**
   * @class
   * @param {HTMLFormElement} form
   */
  // eslint-disable-next-line class-methods-use-this
  set DataForm(form) {
    const lastStepFormData = Object.entries(Object.fromEntries(new FormData(form).entries()));
    const hasWhatsapp = document.querySelector('#hasWhatsapp').checked;
    lastStepFormData.forEach(([key, value]) => {
      if (key !== 'hasWhatsapp') {
        this.data.append(key, value);
      }
    });
    this.data.set('hasWhatsapp', hasWhatsapp);
  }

  showResultInfo() {
    document.querySelector('#form-info').innerHTML = TempCartInfo(this.getJsonData());
    return this;
  }

  manualResetDisabled() {
    /* eslint-disable-next-line */
    for (const [key, value] of Object.entries(this.getJsonData())) {
      const input = document.querySelector(`[name="${key}"]`);
      if (input.disabled) {
        this.DataForm.delete(key);
      }
    }
  }

  finalMessage(title, body) {
    const cart = document.querySelector('.cart-block');
    cart.innerHTML = `<h1 class="title-h1 pb-3">${title}</h1> <div class="title-h6 text-secondary pb-3">${body}</div>`;

    return this;
  }

  /**
   * @param form - ClassName or HtmlElement
   * @returns {OrderFormBySteps}
   */
  pasteUserInfoToFastForm(form) {
    const FormElement = typeof form === 'string' ? document.querySelector(form) : form;
    FormElement.name.value = this.order.querySelector('#name').value;
    FormElement.phone.value = this.order.querySelector('#phone').value;
    return this;
  }
}
